<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="Video Tags" class="common-header">
                <mt-button slot="left" icon="back" @click="backoff()"></mt-button>
                <mt-button slot="right" @click="addtag">Add Tag</mt-button>
            </mt-header>
        </div>
        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div v-if="tag_list">
                <mt-cell-swipe class="goods-item"  v-for="(item, index) in tag_list" v-bind:key="item.svideotag_id" :right="rightBottom(item.svideotag_id)">
                    <div style="width: 100%;" @click="endtags(item.svideotag_id)">
                        <div class="flex-right">
                            <span class="title ml-10">#{{ item.svideotag_name }}</span>
                        </div>
                    </div>
                </mt-cell-swipe>
            </div>
        </div>
        
        <div class="AddTagBoxBack" @click="closeadd" v-show="AddTagBox"></div>
        <div class="AddTagBox"  v-show="AddTagBox">
        	<div class="Addtitle">
        		<p>Add Tag</p>
        	</div>
        	<div class="AddTagContent">
        		<input type="text" name="svideotag_name" v-model="svideotag_name" placeholder="Please enter tag title.">
        		
        	</div>
        	<div class="TagBottom">
        		<span  @click="closeadd">Cancel</span>
        		<span class="submitadd" @click="submitadd">Submit</span>
        	</div>
        </div>
    </div>
</template>

<script>
import { Toast, Indicator, MessageBox} from 'mint-ui'
import { mapState, mapActions } from 'vuex'
import { getTagList,deleteTagList,addTagList,endTagList,getisVideoMan} from '../../../api/video'
export default {
  data () {
    return {
      tagids:"",
      member_id:"",
      AddTagBox:false,
      svideotag_name:"",
      svideotag_desc:"",
      tag_list: false,
      page:0,
      per_page:20,
      member_id:"",
      params: { 'page': 0, 'per_page': 20 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
    }
  },
  components: {
    
  },
  created () {
  	window.onscroll=true;
    if(this.user){
  		this.member_id=this.user.member_id;
  		getisVideoMan(this.user.member_id,this.token).then((res) => {
			if(res.result.isman>0){
				
			}else{
				this.$router.push({ name: 'MemberVideoIndex',query: { gologin: "1" }})
			}
	   })
  	}
  },
  computed: {
    ...mapState({
      config: state => state.config.config,
      isOnline: state => state.member.isOnline,
      user: state => state.member.info,
      token: state => state.member.token
    })
  },
  watch: {

  },
  methods: {
  	//编辑标签
  	endtags:function(tagidss){
  		endTagList(tagidss,this.member_id,this.token).then(res => {
	      	if(res.code==10000){
	      		this.tagids=tagidss;
	      		this.svideotag_name=res.result.video_tag.svideotag_name;
	      		this.svideotag_desc=res.result.video_tag.svideotag_desc
	      		this.AddTagBox=true;
	      	}else{
	      		Toast(res.message)
	      	}
	      	
	    })
  	},
  	//标签提交
  	submitadd:function(){
  		if(this.svideotag_name==""){
  			Toast("Please enter tag title.");
  		}else{
  			addTagList(this.tagids,this.svideotag_name,this.svideotag_desc,this.member_id,this.token).then(res => {
		      	if(res.code==10000){
		      		this.closeadd();
		      		this.tag_list=false;
		      		this.page=0;
		      		this.getTagList();
		      	}else{
		      		
		      	}
		      	Toast(res.message)
		    })
  		}
  	},
    //删除标签按钮
    rightBottom (tagid) {
      return [
        {
          content: 'Delete',
          style: { background: 'red', color: '#fff' },
          handler: () =>
            MessageBox({
              title: 'Delete',
              message: 'Do you want to delete this label?',
              showCancelButton: true,
              confirmButtonText: 'Submit',
      		  cancelButtonText: 'Cancel',
            }).then(action => {
              if (action === 'confirm') {
                this.delFriend(tagid)
              }
            })
        }
      ]
    },
	//删除标签接口
    delFriend (tagid) {
      deleteTagList(tagid,this.member_id,this.token).then(res => {
      	if(res.code==10000){
      		this.tag_list=false;
		    this.page=0;
		    this.getTagList();
      		Toast("Deletion succeeded")
      	}else{
      		Toast("Delete failed")
      	}
      })
    },
    loadMore () {
      this.loading = true
      this.page = ++this.page
      if (this.isMore) {
        this.loading = false
        this.getTagList(true)
      }
    },
	//获取标签
    getTagList () {
      Indicator.open()
      getTagList(this.page,this.member_id,this.token).then(res => {
        Indicator.close()
        if (res.result.tag_list) {
          this.isMore = true
        } else {
          this.isMore = false
        }
//
        let temp = res.result.tag_list
        if (temp) {
          if (!this.tag_list) {
            this.tag_list = temp
          } else {
            this.tag_list.concat(temp)
          }
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    },
    reload () {
      this.params = { 'page': 0, 'per_page': 10 }
      this.page=0;
      this.per_page=10;
      this.tag_list = false
      this.loading = false
      this.isMore = true
      this.loadMore()
    },
    //添加标签弹窗
    addtag:function(){
    	this.tagids="";
    	this.svideotag_name="";
	    this.svideotag_desc="";
    	this.AddTagBox=true;
    },
    //关闭新增弹窗
    closeadd:function(){
    	this.AddTagBox=false;
    },
    //返回上一页
   backoff:function(){
   	var gologin=this.$route.query.gologin;
   	if(gologin && gologin!=undefined){
   		this.$router.push({ name: 'MemberIndex' })
   	}else{
   		this.$router.go(-1);
   	}
   },
  }

}
</script>
<style lang="scss" scoped>
    .goods-item{height:3rem;width:100%;}
    .goods-item .p-img{float:left;padding:0.25rem 0;margin-left:0.5rem;}
    .goods-item .p-img img{width:2.5rem;height:2.5rem;border-radius:50%}
    .flex-right {float:left;}
    .flex-right span{line-height:3rem;display:block;float:left;font-size:0.7rem;}
    .button{float:right;margin-right:.5rem;margin-top:0.7rem}
    .AddTagBoxBack{position: fixed;z-index: 99;left: 0px;top: 0px;width: 100%;height: 100%;background: rgba(0,0,0,0.2);}
    .AddTagBox{position: fixed;z-index: 1000;left: 10%;top: 20%;width: 80%;min-height: 5rem;background: #fff;border-radius: 10px;box-sizing: border-box;padding: 0;overflow: hidden;}
    .Addtitle p{line-height: 1.8rem;text-align: center;font-size: 0.9rem;margin: 0;}
    .Addtitle{border-bottom: 1px solid #ddd;padding: 0.1rem 0;}
    .AddTagContent{padding: 0.2rem 0.5rem;}
    .AddTagContent input{outline: none;border:1px solid #ddd;line-height: 1.8rem;box-sizing: border-box;padding: 0 0.2rem;border-radius: 0.3rem;display: inline-block;width: 100%;margin-top: 0.5rem;}
    .TagBottom{text-align: center;overflow: auto;overflow: auto;margin-top: 0.5rem;}
    .TagBottom span{display: inline-block;width: 50%;float: left;font-size: 0.9rem;line-height: 2.2rem;text-align: center;box-sizing: border-box;}
    .TagBottom span:nth-child(1){border-right: 1px solid #eee;background: #eee;}
    .TagBottom span.submitadd{background: #F01414;color: #fff;}
</style>

<!--Cell Swipe样式覆盖 -->
<style>
    .goods-item .mint-cell-swipe-button {
        width: 4.5rem;
        font-size: 0.7rem;
        display: flex !important;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
    }
    .goods-item .mint-cell-wrapper {
        padding: 0;
    }
    .goods-item .mint-cell-wrapper .mint-cell-value {
        width: 100%;
        border-bottom: 1px solid rgba(232, 234, 237, 1);
    }
</style>
